import React, { useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import {
  $isSuccess,
  closeModal,
  requestHelp,
  requestHelpMounted,
} from './model'
import { useUserProfile } from '../../../../features/user'
import { useUnit } from 'effector-react'

type Props = {
  transactionId: number
  isVisible: boolean
  onClose: () => void
}

export const TransactionHelpModal: React.FC<Props> = ({
  transactionId,
  isVisible,
  onClose,
}) => {
  const userProfile = useUserProfile()
  const isLoading = useUnit(requestHelp.pending)
  const [isSuccess, modalCloseFn] = useUnit([$isSuccess, closeModal])

  const [formValues, setFormValues] = useState({
    question: '',
  })

  const handleSubmit = () => {
    requestHelpMounted({
      transactionRequestId: transactionId,
      managerEmail: userProfile.email,
      question: formValues.question,
    })
  }

  useEffect(() => {
    if (isSuccess) {
      onClose()
      modalCloseFn()
    }
  }, [isSuccess])

  return (
    <CModal
      visible={isVisible}
      onClose={() => {
        onClose()
      }}
      size={'lg'}
    >
      <CModalHeader>
        <CModalTitle>Request help</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow>
          <CCol xs={6}>
            <CFormInput
              label="Question"
              name="question"
              value={formValues.question}
              onChange={(e) => {
                setFormValues((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }}
            />
          </CCol>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          className="px-4"
          onClick={() => {
            if (window.confirm('Are you sure?')) {
              handleSubmit()
            }
          }}
        >
          {isLoading && <span className="spinner-border spinner-border-sm" />}
          Ok
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
